import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import PrivacyPolicyPage from "../components/PrivacyPolicyPage.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/yearly-forecast/:param?",
    name: "YearlyForecast",
    component: Dashboard,
  },
  {
    path: "/monthly-report/:param?",
    name: "MonthlyReport",
    component: Dashboard,
  },
  {
    path: "/yearly-report/:param?",
    name: "YearlyReport",
    component: Dashboard,
  },
  {
    path: "/quartal-report/:param?",
    name: "QuartalReport",
    component: Dashboard,
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicyPage",
    component: PrivacyPolicyPage,
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
